import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, GraduationCap, Sparkles } from "lucide-react";
import { Badge } from "./ui/badge";

const CourseCard = ({ course, index = 0 }) => {
  return (
    <Link to={`/corsi/${course.slug}`} className="course-card block group">
      <article className="bg-white rounded-3xl overflow-hidden border border-emerald-100 h-full flex flex-col">
        <div className="relative aspect-[4/3] overflow-hidden bg-emerald-50">
          <img src={course.image} alt={course.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/60 via-transparent to-transparent"></div>
          {course.tag && (
            <Badge className="absolute top-4 left-4 bg-white text-brand font-semibold hover:bg-white gap-1">
              <Sparkles className="w-3 h-3" />
              {course.tag}
            </Badge>
          )}
          <div className="absolute bottom-4 left-4 right-4 text-white">
            <p className="text-xs uppercase tracking-wider opacity-90 mb-1">{course.fullTitle}</p>
          </div>
        </div>
        <div className="p-6 flex-1 flex flex-col">
          <h3 className="font-display text-2xl font-bold text-brand-dark mb-3">{course.title}</h3>
          <p className="text-sm text-brand-dark/70 leading-relaxed mb-5 flex-1">{course.shortDescription}</p>

          <div className="flex items-center gap-4 text-xs mb-5 pb-5 border-b border-emerald-100">
            <div className="flex items-center gap-1.5 text-brand-dark/70">
              <Clock className="w-3.5 h-3.5 text-brand" />
              <span className="font-semibold">{course.duration}</span>
            </div>
            <div className="flex items-center gap-1.5 text-brand-dark/70">
              <GraduationCap className="w-3.5 h-3.5 text-brand" />
              <span className="font-semibold">{course.price}</span>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <span className="text-sm font-semibold text-brand">Scopri di più</span>
            <div className="w-9 h-9 rounded-full bg-brand-light group-hover:bg-brand text-brand group-hover:text-white flex items-center justify-center transition-colors">
              <ArrowRight className="w-4 h-4" />
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default CourseCard;
